import React from "react";
import { BoxSubTitle, BoxTitle } from "./texts";
import FooterQR from "./QRs/FooterQR.png";

const Footer = () => {
  return (
    <div className="flex justify-center flex-col items-center mb-10">
      <BoxTitle>Descarga la app</BoxTitle>
      <div className="flex w-[60%] p-3">
      <BoxSubTitle>
        Escanea este código QR para descarga la app en tu celular y ver toda la información disponible
      </BoxSubTitle>
      </div>

      <div className="rounded-[16px] border-[2px] border-gray-400 w-40 h-40 flex justify-center items-center p-2">
        <img
        src={FooterQR}
        alt="Casa Ruuf"
        className="w-full h-full object-cover mb-0"
        />
      </div>
    </div>
  );
};

export default Footer;